import { createContext, ReactElement, ReactNode, useContext } from 'react';

export enum AccountLayout {
  POPUP = 'popup',
  ONPAGE = 'onpage'
}

export enum AccountView {
  REGISTER = 'register',
  LOGIN = 'login',
  DEFAULT = 'default'
}

export type AccountProps = {
  configs?: {
    showCart?: boolean;
    accountLayout?: AccountLayout;
    accountView?: AccountView;
    joinWithOneButton?: boolean;
  };
};

type AccountProviderProps = {
  children: ReactNode;
  value: {
    configs: AccountProps['configs'];
  };
};

export const defaultProps: AccountProps = {
  configs: {
    showCart: false,
    accountLayout: AccountLayout.POPUP,
    accountView: AccountView.DEFAULT,
    joinWithOneButton: false
  }
};

export const AccountContext = createContext<AccountProviderProps['value']>({
  configs: defaultProps.configs
});

export const AccountProvider = (props: AccountProviderProps): ReactElement => {
  return (
    <AccountContext.Provider value={props.value}>
      {props.children}
    </AccountContext.Provider>
  );
};

export const useAccountValues = (): AccountProviderProps['value'] => {
  return useContext(AccountContext);
};
